/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

export const GET_BRANDS = gql`
  query getCategory{
    getCategory {
      message,
      data {
        subCategoryId{
            name
            _id
        }
        _id
        name
      }
    }
}`;


export const GET_BRANDS_CATEGORY_TAGS = gql`

query getCategoryTags($searchKey: String, $isCategory: Boolean, $isSubCategory: Boolean, $type: String, $categoryId: String){
  getCategoryTags(searchKey:$searchKey, isCategory:$isCategory, isSubCategory: $isSubCategory, type: $type, categoryId: $categoryId){
    message,
    data{
      name,
      _id,
      label,
      value,
      subCategoryId{
        name,
        _id,
      }
    }
  }
}`;
